import './RemoveAction.scss';
import PropTypes from "prop-types";

const RemoveAction = ({onClick}) => (
    <div
        className="remove-action"
        onClick={onClick}
    />
);

RemoveAction.propTypes = {
    onClick: PropTypes.func
}

export default RemoveAction;
